import { FC } from 'react';
import { DutyActivity as DutyActivityType, Workday, User } from '../models/workday';
import { formatTime } from '../utils/dateTime';
import { Route } from './RouteCard/Route';
import { TripCardContent, TripCard } from './TripCard/TripCard';
import { MainCardContent, MainCard } from './MainCard/MainCard';
import { IconType } from '../enums/IconType';
import { SignInCardContent, SignInCard } from './SignInCard/SignInCard';

type Props = {
  dutyActivity: DutyActivityType;
  currentWorkday: Workday;
  user: User
};

export const DutyActivity: FC<Props> = ({ currentWorkday: workday, dutyActivity: da, user: user }) => {

  if (!isNaN(Number(da.DtyActName))) {
    return <Route workday={workday} dutyActivity={da} user={user}/>;
  } else if (
    da.DtyActName === 'Promenad' &&
    da.Trip[0]?.TravelDuties !== undefined
  )
    return (
      <MainCard>
        <MainCardContent
          primary1={`Res med linje ${da.Trip[0].TrpRoutePublicId != undefined ? da.Trip[0].TrpRoutePublicId : da.Trip[0].TrpRouteTransdevSpecial} - Tur ${da.Trip[0].TrpNumber}`}
          primary2={da.Trip[0].TravelDuties}
          secondary1={
            formatTime(da.DtyActStartTime) + ' - ' + da.DtyActStartPlace
          }
          secondary2={formatTime(da.DtyActEndTime) + ' - ' + da.DtyActEndPlace}
          comment={da.DtyActCommentary}
          icon={IconType.Ride}
        />
      </MainCard>
    );
  else if (
    da.DtyActName.includes('Tomkörning') &&
    da.Trip[0]?.TravelDuties !== undefined
  )
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Ride}
        />
      </MainCard>
    );
    else if (da.DtyActName === 'Promenad')
      return (
        <MainCard>
          <MainCardContent
            primary1={da.DtyActName}
            primary2={''}
            secondary1={
              formatTime(da.DtyActStartTime) + ' - ' + da.DtyActStartPlace
            }
            secondary2={formatTime(da.DtyActEndTime) + ' - ' + da.DtyActEndPlace}
            comment={da.DtyActCommentary}
            icon={IconType.Walk}
          />
        </MainCard>
      );
    else if (da.DtyActActivity === 'Travel from' || da.DtyActActivity === 'Travel to')
      return (
        <TripCard>
          <TripCardContent
            primary1={da.DtyActName}
            primary2={''}
            dutyActivity={da}
            secondary1={
              formatTime(da.DtyActStartTime) + ' - ' + da.DtyActStartPlace
            }
            secondary2={formatTime(da.DtyActEndTime) + ' - ' + da.DtyActEndPlace}
            comment={da.DtyActCommentary}
            icon={IconType.Walk}
          />
        </TripCard>
      );
  else if (da.DtyActName === 'Paus')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Coffee}
        />
      </MainCard>
    );
    else if (da.DtyActName === 'bussnrsignin')
      return (
        <SignInCard>
        <SignInCardContent
          time={da.DpceExpectArrival as string}
          signedIn={da.SignedIn as boolean}
          globalSignIn={user.IsSignedIn as boolean}
        />
      </SignInCard>
      );
    else if (da.DtyActName === 'Fordonsvård')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Cleaning}
        />
      </MainCard>
    );  
    else if (da.DtyActName === 'Tankning')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.LocalGasStation}
        />
      </MainCard>
    );
    else if (da.DtyActName === 'APT')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Group}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Rast')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Food}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Delad rast')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Split}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Reserv')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Reserve}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Övrigt')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Other}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Påtid')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.CheckIn}
        />
      </MainCard>
    );
  else if (da.DtyActName === 'Klargöring in')
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Check}
        />
      </MainCard>
    );
  else if (
    da.DtyActName === 'Uppehåll' ||
    da.DtyActName === 'Garantitid' ||
    da.DtyActName === 'Betald rast' ||
    da.DtyActName === 'Paid OT break' ||
    da.DtyActName === 'Unpaid OT break' ||
    da.DtyActName.includes('Avtid')
  )
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Wait}
        />
      </MainCard>
    );
    else if(
      da.DtyActName === 'Väntetid'
    )
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.HourglassEmpty}
        />
      </MainCard>
    );
  else if (
    da.DtyActName === 'Waiting before' ||
    da.DtyActName === 'Waiting after' ||
    da.DtyActName.includes('Delay')
  )
      return null;

    if (Array.isArray(da.Trip) && da.Trip.length > 0) {
        return <Route workday={workday}  dutyActivity={da} user={user} />;
    }

  else
    return (
      <MainCard>
        <MainCardContent
          primary1={da.DtyActName}
          primary2={da.DtyActStartPlace}
          secondary1={formatTime(da.DtyActStartTime)}
          secondary2={formatTime(da.DtyActEndTime)}
          comment={da.DtyActCommentary}
          icon={IconType.Unknown}
        />
      </MainCard>
    );
};
